<template>
  <div id="system-checklist-add">
    <ipub-model :title="`${params.id?'Edit':'Add'} ${typeObj[type]}`"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="checklist-add-form"
                 :model="params"
                 autocomplete="off"
                 :rules="rules">
        <ipub-form-item prop="email"
                        label="Email">
          <ipub-input placeholder="Email"
                      :disabled="!!this.params.id"
                      v-model.trim="params.email" />
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="firstName"
                            label="First Name">
              <ipub-input placeholder="First Name"
                          v-model.trim="params.firstName" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="lastName"
                            label="Last Name">
              <ipub-input placeholder="Last Name"
                          v-model.trim="params.lastName" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <template v-if="type==='REVIEWER_UNSUBSCRIBE'">
          <ipub-form-item prop="journalId"
                          label="Journal">
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         :disabled="!!this.params.id"
                         :options="journalList" />
          </ipub-form-item>
          <ipub-row :gutter="20">
            <ipub-col :span="6">
              <ipub-form-item prop="unsubscribeTime"
                              label="Unsubscribe Date">
                <ipub-date-picker placeholder="Choose Unsubscribe Date"
                                  v-model="params.unsubscribeTime" />
              </ipub-form-item>
            </ipub-col>
            <ipub-col :span="6">
              <ipub-form-item prop="expiredTime"
                              label="Released Date">
                <ipub-date-picker placeholder="Choose Released Date"
                                  v-model="params.expiredTime" />
              </ipub-form-item>
            </ipub-col>
          </ipub-row>
        </template>
        <ipub-form-item prop="remark"
                        label="Note">
          <ipub-textarea placeholder="Note"
                         v-model.trim="params.remark" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mailAddress } from '@/api/mail'
import help from '@/utils/help'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: ''
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
    journalList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      params: {},
      rules: {},
      typeObj: {
        PUBLISHER_BLACKLIST: 'Publisher Blacklist',
        REVIEWER_UNSUBSCRIBE: 'Reviewer Unsubscribe',
        SYSTEM_BOUNCE: 'System Bounced',
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      } else {
        if (this.inputData.id) {
          this.getQuery(this.inputData.id)
        } else {
          this.params = {
            unsubscribeTime: this.$moment(),
            expiredTime: this.$moment().add(1, 'y')
          }
        }
      }
    }
  },
  mounted () {
    this.getRules()
    help.closeAutocomplete()

  },
  methods: {
    async getQuery (id) {
      this.params = await mailAddress.getQuery(this.type, id, { journalId: this.inputData.journalId })
    },
    async confirm () {
      const flag = this.$refs['checklist-add-form'].validate()
      if (flag) {
        if (this.params.id) {
          await mailAddress.editQuery(this.type, this.params.id, this.params)
          this.$message.success({ title: 'Success', content: 'Update successfully!' })
        } else {
          await mailAddress.addQuery(this.type, this.params)
          this.$message.success({ title: 'Success', content: 'Add successfully!' })
        }
        this.$emit('confirm', this.params)
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        email: [
          {
            required: true,
            message:
              'Email' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        firstName: [
          {
            required: true,
            message:
              'First Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        lastName: [
          {
            required: true,
            message:
              'Last Name' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        journalId: [
          {
            required: true,
            message:
              'Journal' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        remark: [
          {
            required: true,
            message:
              'Note' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#system-database-add {
  .upload-content {
    height: 77px;
    width: 253px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .file-content {
    width: 84%;
    height: 40px;
    margin-right: 15px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d9dfe2;
    line-height: 40px;
    padding: 0 12px;
  }
}
</style>
